import React, { useEffect } from "react";
import connect from "stores/connect";
import { MongoDBDataAdapterStore, MongoDBDataAdapterActions } from "../stores/MongoDBDataAdapterStore";
const MongoDBDataAdapterSummary = ({ statsData, dataAdapter }) => {
  useEffect(() => {
    MongoDBDataAdapterActions.stats(dataAdapter.id);
  }, [dataAdapter]);
  return /* @__PURE__ */ React.createElement("dl", null, /* @__PURE__ */ React.createElement("dt", null, "Database Entries"), /* @__PURE__ */ React.createElement("dd", null, (statsData == null ? void 0 : statsData.entriesCount) || 0), /* @__PURE__ */ React.createElement("dt", null, "CIDR lookup"), /* @__PURE__ */ React.createElement("dd", null, dataAdapter.config.cidr_lookup ? "yes" : "no"));
};
export default connect(
  MongoDBDataAdapterSummary,
  { adapter: MongoDBDataAdapterStore },
  (props) => {
    var _a;
    return {
      ...props,
      statsData: ((_a = props.adapter) == null ? void 0 : _a.statsData) || 0
    };
  }
);
